<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            [maxLength]="128"
            label="Program Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Program Name" />
    </div>

    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="description"
            [maxLength]="128"
            label="Description" />
    </div>
</div>
